<template>
	<div>
		<inertia-head title="Member Information" />
		<div class="bg-primary">
			<div class="bg-black-25">
				<div class="content text-center">
					<div class="py-0">
						<h1 class="fw-bold text-white mb-2">Member Information</h1>
						<h2 class="h4 fw-normal text-white-75 fs-sm">
							Manage member information
						</h2>
					</div>
				</div>
			</div>
		</div>
		<div class="content mt-5">
			
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">
						<inertia-link
							:href="route('admin.user-management.members.index')"
							class="btn btn-alt-secondary btn-sm"
						>
							<i class="si si-action-undo me-1"></i> Back to list of members
						</inertia-link>
					</h3>
					<div class="block-options space-x-1">
						<span v-if="member.is_super_sponsor==1" class="text-success fw-bold">SUPER AFFILIATE</span>
					</div>
					<div class="block-options space-x-1 ms-2">
						<div class="input-group">
							<span class="form-control border-info fw-bold">GR: {{member.cur_gr || 'NONE' }}</span>
							<span v-if="member.cur_gr==null && member.is_expired==0" class="input-group-btn">
								<inertia-link :href="'/crons/sendto/getresponse/campaign?email='+member.username+'&gr_retro='+member.gr_retro" target="" class="btn btn-success"><i class="fa fa-arrow-up me-1"></i>Submit</inertia-link>
							</span>
						</div>
					</div>
				</div>
				<div class="block-content">
					<div class="row">
						<div class="col space-x-1 pb-4 text-end">
							<div class="btn-group mb-1" role="group">
								<button
									id="btnGroupDrop1"
									type="button"
									class="btn btn-warning btn-sm dropdown-toggle"
									data-bs-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i class="fa fa-cogs me-1"></i>
									Manage Account
								</button>
								<div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
									<a
										v-if="member.password_expired"
										class="dropdown-item"
										href="javascript:void(0);"
										@click="cancelPasswordReset"
									>
										Cancel Flag
									</a>
									<a
										v-else
										class="dropdown-item"
										href="javascript:void(0);"
										@click="forcePasswordReset"
									>
										Force password reset
									</a>
									<a
										class="dropdown-item"
										href="javascript:void(0);"
										@click="resendPasswordResetLink"
									>
										Resend Password reset link
									</a>
									<a
										@click="cancelSubscriptionModal.toggleModal()"
										class="dropdown-item"
										href="#"
									>
										Cancel subscription
									</a>
									<div class="dropdown-divider"></div>
									<a v-if="member.current_rank!='BCC'"
										@click="expiredDiscountModal.toggleModal()"
										class="dropdown-item"
										href="#"
									>
										Special Discount
									</a>
									<div class="dropdown-divider"></div>
									<a
										@click="signInLogsModal.toggleModal()"
										class="dropdown-item"
										href="#"
									>
										Sign-in logs
									</a>
									<div class="dropdown-divider"></div>
									<a class="dropdown-item"
										:href="route('admin.resubscribe-getresponse',{fname:member.fname,lname:member.lname,email:member.username,rank:member.current_rank})" target="_blank"
									>
										Re-Subscribe to Getresponse
									</a>
									<div v-if="member.current_rank=='GOLD'">
										<div class="dropdown-divider"></div>
										<a class="dropdown-item" href="#" @click="processGoldLifetimeOffer()" :disabled="formGoldLifetimeOffer.processing">
											<div v-if="formGoldLifetimeOffer.processing" class="spinner-border spinner-border-sm text-dark mr-1" role="status" >
												<span class="sr-only mr-1">Please wait...</span>
											</div>
											<span v-if="member.set_gold_lifetime_offer==0">Set </span> 
											<span v-else>Remove </span> 
											Gold Lifetime Offer
										</a>
									</div>
								</div>
							</div>
							<div class="btn-group mb-1" role="group">
								<button
									id="btnGroupDrop2"
									type="button"
									class="btn btn-success btn-sm dropdown-toggle"
									data-bs-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i class="fa fa-arrow-up"></i>
									<i class="fa fa-arrow-down me-1"></i>
									Manage Membership
								</button>
								<div class="dropdown-menu" aria-labelledby="btnGroupDrop2">
									<a
										v-if="member.current_rank !== 'PLATINUM FAITHFUL'"
										@click="upgradeMembershipModal.toggleModal()"
										class="dropdown-item"
										href="#"
									>
										<i class="fa fa-arrow-up me-1"></i>
										Upgrade membership
									</a>
									<a
										v-if="member.current_rank !== 'SILVER'"
										@click="downgradeMembershipModal.toggleModal()"
										class="dropdown-item"
										href="#"
									>
										<i class="fa fa-arrow-down me-1"></i>
										Downgrade membership
									</a>
								</div>
							</div>
							<button
								@click="showBeneficiariesModal.toggleModal()"
								type="button"
								class="btn btn-primary btn-sm mb-1"
							>
								<i class="fa fa-users me-1"></i>
								Show Beneficiaries
							</button>
							<button
								@click="welcomeCallModal.toggleModal()"
								type="button"
								class="btn btn-info btn-sm mb-1"
							>
								<i class="si si-call-out me-1"></i>
								Welcome Call
							</button>
							<button
								v-if="
									!member.has_bcc ||
									['Cancelled', 'Refunded'].includes(member.bcc_status)
								"
								@click="addBCCModal.toggleModal()"
								type="button"
								class="btn btn-secondary btn-sm mb-1"
							>
								<i class="fa fa-plus me-1"></i>
								Add BCC
							</button>
							<button
								@click="tagSuperSponsorConfirmModal.toggleModal()"
								type="button"
								class="btn btn-sm mb-1"
								:class="{'btn-success':member.is_super_sponsor==0,'btn-danger':member.is_super_sponsor==1}"
							>
								<span>
									<i class="fa fa-tag me-1"></i>
									<span v-if="member.is_super_sponsor==0">Tag as Super Affiliate</span>
									<span v-else>Remove as Super Affiliate</span>
								</span>
							</button>
						</div>
					</div>
					<div v-if="member" class="row pt-4">
						<div class="col-md-6">
							<form @submit.prevent="saveMemberInfo" class="mb-5">
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Transfered</label>
									<div class="col-sm-8">
										<input
											type="text"
											class="form-control"
											:value="member.transfer_complete ? 'YES' : 'NO'"
											readonly
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Member ID</label>
									<div class="col-sm-8">
										<input
											v-model="member.counter"
											type="text"
											class="form-control"
											readonly
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Membership</label>
									<div class="col-sm-8">
										<!-- <input
											v-model="member.rank_format"
											type="text"
											class="form-control"
											readonly
										/> -->
										<div class="form-control">{{member.rank_format}}</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Expiry</label>
									<div class="col-sm-8">
										<flat-pickr
											id="expiry"
											v-model="memberInfoForm.expiry"
											class="form-control"
											placeholder="Enter expiry date"
											:config="{
												altInput: true,
												altFormat: 'F j, Y',
												dateFormat: 'Y-m-d',
												wrap: true,
											}"
											:class="
												memberInfoForm.errors.expiry
													? 'flatpickr-input is-invalid border-danger'
													: 'flatpickr-input'
											"
										/>
										<div
											v-if="memberInfoForm.errors.expiry"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.expiry }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label
										class="col-sm-4 col-form-label"
										:class="{
											'text-danger': memberInfoForm.errors.expiry_remarks,
										}"
									>
										Expiry Remarks
									</label>
									<div class="col-sm-8">
										<textarea
											v-model="memberInfoForm.expiry_remarks"
											class="form-control"
											:class="{
												'is-invalid': memberInfoForm.errors.expiry_remarks,
											}"
											rows="10"
										></textarea>
										<div
											v-if="memberInfoForm.errors.expiry_remarks"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.expiry_remarks }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">First Name</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.fname"
											type="text"
											class="form-control"
											:class="{ 'is-invalid': memberInfoForm.errors.fname }"
										/>
										<div
											v-if="memberInfoForm.errors.fname"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.fname }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Middle Name</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.mname"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Last Name</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.lname"
											type="text"
											class="form-control"
											:class="{ 'is-invalid': memberInfoForm.errors.lname }"
										/>
										<div
											v-if="memberInfoForm.errors.lname"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.lname }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Birthdate</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.bday"
											type="date"
											class="form-control"
											:class="{ 'is-invalid': memberInfoForm.errors.bday }"
										/>
										<div
											v-if="memberInfoForm.errors.bday"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.bday }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Date Registered</label>
									<div class="col-sm-8">
										<input
											v-model="member.dateregs"
											type="text"
											class="form-control"
											readonly
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Time Registered</label>
									<div class="col-sm-8">
										<input
											v-model="member.timeregs"
											type="text"
											class="form-control"
											readonly
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">City/Province</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.address"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Mobile Number</label>
									<div class="col-sm-8">
										<vue-tel-input
											@input="onInput"
											@countryChanged="onCountryChange"
											v-model="memberInfoForm.mobile"
											:value="memberInfoForm.mobile"
											:defaultCountry="memberInfoForm.country_code"
											:inputOptions="{ showDialCode: true }"
											mode="international"
											class="form-control"
											:class="{ 'is-invalid': memberInfoForm.errors.mobile }"
										/>
										<div
											v-if="memberInfoForm.errors.mobile"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.mobile }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Email Address</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.email"
											type="email"
											class="form-control"
											:class="{ 'is-invalid': memberInfoForm.errors.email }"
										/>
										<div
											v-if="memberInfoForm.errors.email"
											class="invalid-feedback"
										>
											{{ memberInfoForm.errors.email }}
										</div>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Tax ID Number</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.tin"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">IP Address</label>
									<div class="col-sm-8">
										<input
											v-model="member.ipadd"
											type="text"
											class="form-control"
											readonly
										/>
									</div>
								</div>
								<div class="row mb-4">
									<label class="col-sm-4 col-form-label">Tax</label>
									<div class="col-sm-8">
										<input
											v-model="memberInfoForm.tax_percentage"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
								<div class="mb-4 space-x-1 text-end">
									<button
										type="submit"
										class="btn btn-alt-primary"
										:disabled="
											memberInfoForm.processing || !memberInfoForm.isDirty
										"
									>
										<i class="fa fa-save me-1"></i>
										Save changes
									</button>
									<button
										@click="memberInfoForm.reset()"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>
										Reset
									</button>
								</div>
							</form>
						</div>
						<div class="col-md-6">
							<div class="row mb-4">
								<div class="my-2 h3 text-center">
									<span class="badge me-1" :class="{'bg-success':member.customer_id!==null && member.renew_status!='Cancelled','bg-danger':member.customer_id!==null && member.renew_status=='Cancelled','bg-secondary':member.customer_id==null}">Renewal Status: {{member.customer_id!==null && member.renew_status=='Cancelled'? 'Inactive': member.customer_id===null ?'N/A':'Active'}}</span>
								</div>
							</div>
							<div class="row mb-4">
								<label class="col-sm-4 col-form-label">
									Current Role (Coach)
								</label>
								<div class="col-sm-8">
									<div class="input-group">
										<select v-model="form.role" class="form-select">
											<option value="NONE">NONE</option>
											<option value="COACH">COACH</option>
										</select>
										<button
											@click="setRole"
											type="button"
											class="btn btn-alt-primary"
										>
											<i class="fa fa-save me-1"></i> 
											Save
										</button>
									</div>
								</div>
							</div>
							<!-- <div class="row mb-4">
								<label class="col-sm-4 col-form-label">
									Current Renew Status
								</label>
								<div class="col-sm-8">
									<div class="input-group">
										<select v-model="form.renew_status" class="form-select">
											<option :value="null">ACTIVE</option>
											<option value="Cancelled">CANCELLED</option>
										</select>
										<button
											@click="setRenewStatus"
											type="button"
											class="btn btn-alt-primary"
										>
											<i class="fa fa-save me-1"></i> 
											Save
										</button>
									</div>
								</div>
							</div> -->
							<div class="row">
								<div class="col-lg-4">
									<p class="col-form-label">Change Password</p>
								</div>
								<div class="col-lg-8">
									<form class="mb-5">
										<div class="mb-4">
											<label class="form-label" for="example-ltf-email">
												Email
											</label>
											<input
												v-model="form.email"
												type="email"
												class="form-control"
											/>
										</div>
										<div class="mb-4">
											<label
												class="form-label"
												:class="{ 'text-danger': errors.password }"
											>
												Password
											</label>
											<input
												v-model="form.password"
												type="text"
												class="form-control"
												:class="{ 'is-invalid': errors.password }"
											/>
											<div v-if="errors.password" class="invalid-feedback">
												{{ errors.password }}
											</div>
										</div>
										<div class="mb-4 text-end">
											<button
												@click="changePassword"
												type="button"
												class="btn btn-alt-primary"
												:disabled="!form.password"
											>
												<i class="fa fa-save me-1"></i>
												Change password
											</button>
										</div>
									</form>
								</div>
							</div>
							<div class="row">
								<div class="mb-4">
									<small>
										<span class="fw-semibold">Note:</span> Saving sponsor will
										trigger a distribution of commission. Double check sponsor
										email and ID.
									</small>
								</div>
								<div class="col-lg-4">
									<p class="col-form-label">Sponsor</p>
								</div>
								<div class="col-lg-8">
									<form class="mb-5">
										<div class="mb-4">
											<label
												class="form-label"
												:class="{ 'text-danger': errors.sponsor_email }"
											>
												Sponsor email
											</label>
											<input
												v-model="sponsorForm.sponsor_email"
												type="email"
												class="form-control"
												:class="{ 'is-invalid': errors.sponsor_email }"
											/>
											<div v-if="errors.sponsor_email" class="invalid-feedback">
												{{ errors.sponsor_email }}
											</div>
										</div>
										<div class="mb-4">
											<label
												class="form-label"
												:class="{ 'text-danger': errors.sponsor_id }"
											>
												Sponsor ID
											</label>
											<input
												v-model="sponsorForm.sponsor_id"
												type="text"
												class="form-control"
												:class="{ 'is-invalid': errors.sponsor_id }"
											/>
											<div v-if="errors.sponsor_id" class="invalid-feedback">
												{{ errors.sponsor_id }}
											</div>
										</div>
										<div class="mb-4 text-end">
											<button
												@click="saveSponsor"
												type="button"
												class="btn btn-alt-primary"
												:disabled="['',null].includes(sponsorForm.sponsor_email) || sponsorForm.sponsor_id==0"
											>
												
												<span v-if="!sponsorForm.processing">
													<i class="fa fa-save me-1"></i> Save sponsor
												</span>
												<span v-else>
													<div class="spinner-border spinner-border-sm text-dark" role="status" >
														<span class="sr-only mr-1">Please wait...</span>
													</div>
													<span class="mx-2">Please wait...</span>
												</span>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="alert alert-warning">Member cannot be found</div>
					</div>
				</div>
			</div>


			<modal ref="renewManualModal" size="modal-md">
				<template #title>
					ADD OPS REQUEST
				</template>
				<template #body>
					<div class="mb-4 text-center">
						<span class="badge bg-info fs-3">{{member.current_rank}}</span>
					</div>
					<div class="mb-4">
						<label>Subscription</label>
						<select v-model="formRenew.prod_id" class="form-select">
							<option v-for="(prod,pIndex) in products" :value="prod.prod_id">{{prod.membership_type}} ({{prod.post_amount}})</option>
						</select>
					</div>
					<div class="mb-4">
						<label>Payment Mode</label>
						<select v-model="formRenew.pmethod" class="form-select">
							<option value="POS">POS</option>
							<option value="CASH">CASH</option>
							<option value="QRCODE">QR CODE</option>
						</select>
					</div>
					<div class="mb-4">
						<label>Ref#</label>
						<input type="text" v-model="formRenew.refno" name="refno" class="form-control"/>
					</div>
					<div class="mb-4">
						<label>Remarks</label>
						<textarea v-model="formRenew.remarks" class="form-control" rows="5"></textarea>
					</div>
				</template>
				<template #footer>
					<button @click="renewSubscriptionManual" type="button" class="btn btn-sm btn-success" :disabled="formRenew.processing">
						<div
							v-if="formRenew.processing"
							class="spinner-border spinner-border-sm me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<span v-if="!formRenew.processing">
							<i class="fa fa-save me-1"></i>
						</span>
						Save
					</button>
					<button type="button" class="btn btn-sm btn-danger" @click="renewManualModal.toggleModal()" :disabled="formRenew.processing"><i class="fa fa-times"></i> Cancel</button>
				</template>
			</modal>


			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Membership Ops Request</h3>
					<h3 class="block-options">
						<button type="button" @click="renewManualModal.toggleModal()" class="btn btn-info btn-sm"><i class="fa fa-plus me-1"></i>Renew</button>
					</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>DATE</th>
									<th>TXNID</th>
									<th>MOP</th>
									<th>AMOUNT</th>
									<th>COURSE</th>
									<th>EXPIRY</th>
									<th>SOURCE</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(ops,o_index) in opsRequest.data">
									<td>{{ops.rdate}}</td>
									<td>{{ops.txnid}}</td>
									<td>{{ops.mop}}</td>
									<td>{{ops.amount}}</td>
									<td>{{ops.course}}</td>
									<td>{{ops.cdate}}</td>
									<td>{{ops.source}}</td>
								</tr>
								<tr v-if="opsRequest.data.length <= 0">
									<td colspan="7" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
					<pagination v-if="opsRequest.data.length > 0" :collections="opsRequest" />
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Welcome Calls</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>LOCATION</th>
									<th>MOBILE#</th>
									<th>REMARKS</th>
									<th>STATUS</th>
									<th>CALLEDBY</th>
									<th>CALL DATETIME</th>
									<th>CREATED</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(call,c_index) in welcomeCalls.data">
									<td>{{call.location}}</td>
									<td>{{call.mobile_no}}</td>
									<td>{{call.remarks}}</td>
									<td>{{call.status}}</td>
									<td>{{call.calledby}}</td>
									<td>{{call.call_datetime}}</td>
									<td>{{call.created_at}}</td>
								</tr>
								<tr v-if="welcomeCalls.data.length <= 0">
									<td colspan="7" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
					<pagination v-if="welcomeCalls.data.length > 0" :collections="welcomeCalls" />
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Manage Membership</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>MEMBERSHIP</th>
									<th>FROM</th>
									<th>TO</th>
									<th>REASON</th>
									<th>PROCESSED BY</th>
									<th>IP</th>
									<th>CREATED</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(call,c_index) in manageMembership">
									<td>{{call.membership}}</td>
									<td>{{call.from_membership}}</td>
									<td>{{call.to_membership}}</td>
									<td>{{call.reason}}</td>
									<td>{{call.processed_by}}</td>
									<td>{{call.ipaddress}}</td>
									<td>{{call.created_at}}</td>
								</tr>
								<tr v-if="manageMembership.length <= 0">
									<td colspan="7" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Other Subscription</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>PRODUCT</th>
									<th>EXPIRY</th>
									<th>AMOUNT</th>
									<th>STATUS</th>
									<th>ADDED BY</th>
									<th>MEMBER AT</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(other_sub,os_index) in otherSubscriptions">
									<td>{{other_sub.codetype}}</td>
									<td>{{other_sub.expiry}}</td>
									<td>{{other_sub.amount}}</td>
									<td>{{other_sub.status}}</td>
									<td>{{other_sub.addedby}}</td>
									<td>{{other_sub.member_at}}</td>
								</tr>
								<tr v-if="otherSubscriptions.length <= 0">
									<td colspan="6" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Cancelled Subscription</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>OWNER</th>
									<th>PRODUCT</th>
									<th>REASON</th>
									<th>REFUNDED AMOUNT</th>
									<th>REMARKS</th>
									<th>CANCELLED BY</th>
									<th>CREATED</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(other_can,o_index) in cancelledSubscriptions">
									<td>{{other_can.owner}}</td>
									<td>{{other_can.product_name}}</td>
									<td>{{other_can.reason}}</td>
									<td>{{other_can.refunded_amount}}</td>
									<td>{{other_can.remarks}}</td>
									<td>{{other_can.cancelled_by}}</td>
									<td>{{other_can.date_created}}</td>
								</tr>
								<tr v-if="cancelledSubscriptions.length <= 0">
									<td colspan="7" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Failed Auto Renewal</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>TRIAL1</th>
									<th>MESSAGE1</th>
									<th>TRIAL2</th>
									<th>MESSAGE2</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(failed,f_index) in failedAutoRenewal.data">
									<td>{{failed.trial1date}}</td>
									<td>{{failed.trial1msg}}</td>
									<td>{{failed.trial2date}}</td>
									<td>{{failed.trial2msg}}</td>
								</tr>
								<tr v-if="failedAutoRenewal.data.length <= 0">
									<td colspan="4" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
					<pagination v-if="failedAutoRenewal.data.length > 0" :collections="failedAutoRenewal" />
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-header block-header-default">
					<h3 class="block-title">Referral Commissions</h3>
				</div>
				<div class="block-content">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>DATE</th>
									<th>FROM MEMBER ID</th>
									<th>FROM NAME</th>
									<th>LEVEL</th>
									<th>AMOUNT</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(comm,c_index) in commissions.data">
									<td>{{comm.transdate}}</td>
									<td>{{comm.galingkay}}</td>
									<td>
										{{comm.from_fullname}}
										<div class="text-info">{{comm.g_owner}}</div>
									</td>
									<td>{{comm.level}}</td>
									<td>{{comm.amount}}</td>
								</tr>
								<tr v-if="commissions.data.length <= 0">
									<td colspan="5" class="p-3 text-center fw-bold text-danger">No Record Found</td>
								</tr>
							</tbody>
						</table>
					</div>
					<pagination v-if="commissions.data.length > 0" :collections="commissions" />
				</div>
			</div>
		</div>
		<add-b-c-c
			ref="addBCCModal"
			:member="member"
			:user="user"
			:products="bccProducts"
		/>
		<welcome-call ref="welcomeCallModal" :member="member" :admin="user" />
		<show-beneficiaries
			ref="showBeneficiariesModal"
			:beneficiaries="beneficiaries"
		/>
		<upgrade-membership
			v-if="member.current_rank !== 'PLATINUM FAITHFUL'"
			ref="upgradeMembershipModal"
			:member="member"
			:ranks="upgradeRanks"
			:user="user"
		/>
		<downgrade-membership
			v-if="member.current_rank !== 'SILVER'"
			ref="downgradeMembershipModal"
			:member="member"
			:ranks="downgradeRanks"
			:user="user"
		/>
		<cancel-subscription
			ref="cancelSubscriptionModal"
			:admin="user"
			:member="member"
			:other-subscriptions="otherSubscriptions"
		/>

		<expired-discount
			ref="expiredDiscountModal"
			:admin="user"
			:member="member"
			:expired-discount="expiredDiscount"
		/>

		<sign-in-logs ref="signInLogsModal" :sign-in-logs="signInLogs" />


		<modal ref="tagSuperSponsorConfirmModal">
			<template #title>
				Super Affiliate Confirmation
			</template>
			<template #body>
				<p v-if="member.is_super_sponsor==0" class="fw-semibold">Are you sure, you want to tag this member as a super affiliate?</p>
				<p v-else class="fw-semibold">Are you sure, you want to remove the tagged as a super affiliate?</p>
			</template>
			<template #footer>
				<button @click="tagSuperSponsor" type="button" class="btn btn-success btn-sm me-2">
					
					<span v-if="!tagSuperSponsorForm.processing">
						<i class="fa fa-tag me-1"></i>
						<span>Yes</span>
					</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
				</button>
				<button @click="tagSuperSponsorConfirmModal.toggleModal()" type="button" class="btn btn-danger btn-sm me-2" :disabled="tagSuperSponsorForm.processing">	
					<span>
						<i class="fa fa-times me-1"></i>
						<span>No</span>
					</span>
				</button>
			</template>
		</modal>

	</div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useForm } from '@inertiajs/inertia-vue3'
import {
	AddBCC,
	SignInLogs,
	WelcomeCall,
	ShowBeneficiaries,
	UpgradeMembership,
	CancelSubscription,
	ExpiredDiscount,
	DowngradeMembership,
} from '../../../Components/Admin/Members/Modals'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		user 					: Object,
		flash 					: Object,
		member 					: Object,
		expiredDiscount 		: Object,
		errors 					: Object,
		products 				: Array,
		bccProducts 			: Array,
		upgradeRanks 			: Array,
		downgradeRanks 			: Array,
		otherSubscriptions 		: Object,
		beneficiaries 			: Object,
		signInLogs 				: Object,
		opsRequest 				: Object,
		welcomeCalls 			: Object,
		manageMembership 		: Object,
		otherSubscriptions 		: Object,
		cancelledSubscriptions 	: Object,
		failedAutoRenewal 		: Object,
		commissions 			: Object,
	},
	components: {
		AddBCC,
		WelcomeCall,
		ShowBeneficiaries,
		UpgradeMembership,
		CancelSubscription,
		ExpiredDiscount,
		DowngradeMembership,
		SignInLogs,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
		
		const showBeneficiariesModal = ref(null)

		const signInLogsModal = ref(null)

		const welcomeCallModal = ref(null)

		const downgradeMembershipModal = ref(null)

		const upgradeMembershipModal = ref(null)

		const renewManualModal = ref(null)

		const addBCCModal = ref(null)

		const cancelSubscriptionModal = ref(null)

		const expiredDiscountModal = ref(null)

		const tagSuperSponsorConfirmModal = ref(null)

		const onInput = (number, phoneObject) => {
			if (phoneObject?.formatted) {
				memberInfoForm.mobile = phoneObject.number
				memberInfoForm.country_calling_code = phoneObject.countryCallingCode
			}
		}

		const onCountryChange = (countryObject) => {
			memberInfoForm.country_code = countryObject.iso2
		}

		const memberInfoForm = useForm(props.member)

		const formRenew = useForm({
			member_uuid: props.member.member_uuid,
			prod_id 	: null,
			pmethod 	: 'CASH',
			refno 		: null,
			remarks 	: null
		});

		const formGoldLifetimeOffer = useForm({
			member_uuid: props.member.member_uuid,
			fname: props.member.fname,
			set_gold_lifetime_offer: props.member.set_gold_lifetime_offer,
		});

		const form = useForm({
			id: props.member.counter,
			role: props.member.role,
			renew_status: props.member.renew_status,
			email: props.member.email,
			password: null,
			sponsor_email: props.member.sponsorowner,
			sponsor_id: props.member.sponsorlock,
		})

		const sponsorForm = useForm({
			id: props.member.counter,
			sponsor_email: props.member.sponsorowner,
			sponsor_id: props.member.sponsorlock,
		})

		const tagSuperSponsorForm = useForm({
			id: props.member.counter,
			is_super_sponsor: props.member.is_super_sponsor
		})

		const forcePasswordReset = () => {
			Inertia.post(
				route('admin.post.force-password-reset'),
				{
					admin: props.user.full_name,
					email: props.member.email,
				},
				{
					preserveState: true,
					preserveScroll: true,
				}
			)
		}

		const cancelPasswordReset = () => {
			Inertia.post(
				route('admin.post.cancel-password-reset'),
				{
					admin: props.user.full_name,
					email: props.member.email,
				},
				{
					preserveState: true,
					preserveScroll: true,
				}
			)
		}

		const resendPasswordResetLink = () => {
			Inertia.post(
				route('admin.post.reset-password'),
				{
					email: props.member.email,
				},
				{
					preserveState: true,
					preserveScroll: true,
				}
			)
		}

		const processGoldLifetimeOffer = ()=>{
			formGoldLifetimeOffer.set_gold_lifetime_offer = props.member.set_gold_lifetime_offer;
			formGoldLifetimeOffer.post(
				route('admin.user-management.post.set-gold-lifetime-offer'),
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
				}
			)
		}

		const saveMemberInfo = () => {
			memberInfoForm
				.transform((data) => ({
					...data,
					mobile: data.mobile.replace(/\s+/g, ''),
				}))
				.put(
					route('admin.user-management.members.update', props.member.counter),
					{
						preserveState: true,
						preserveScroll: true,
						only: ['errors', 'flash','member'],
					}
				)
		}

		const setRole = () => {
			Inertia.post(
				route('admin.post.set-role'),
				{
					id: props.member.counter,
					role: form.role,
				},
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
				}
			)
		}

		const setRenewStatus = () => {
			Inertia.post(
				route('admin.post.set-renew-status'),
				{
					id: props.member.counter,
					renew_status: form.renew_status,
				},
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
				}
			)
		}

		const changePassword = () => {
			Inertia.post(
				route('admin.post.change-password'),
				{
					id: props.member.counter,
					password: form.password,
				},
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
					onSuccess: () => form.reset('password'),
				}
			)
		}

		const saveSponsor = () => {
			sponsorForm.post(
				route('admin.post.save-sponsor'),
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
				}
			)
		}


		const tagSuperSponsor = () => {
			tagSuperSponsorForm.post(
				route('admin.post.save-super-sponsor'),
				{
					preserveState: true,
					preserveScroll: true,
					only: ['errors', 'flash','member'],
					onSuccess:()=>{
						tagSuperSponsorForm.is_super_sponsor = props.member.is_super_sponsor;
						tagSuperSponsorConfirmModal.value.toggleModal();
					}
				}
			)
		}


		const renewSubscriptionManual = () => {
			formRenew.post(
				route('admin.post.renew-manual'),
				{
					preserveState: true,
					preserveScroll: true,
					only: ['user,flash,member,expiredDiscount,errors,products,upgradeRanks,downgradeRanks,signInLogs,opsRequest,welcomeCalls,manageMembership,commissions'],
					onSuccess:()=>{
						renewManualModal.value.toggleModal();
					}
				}
			)
		}


		return {
			form,
			sponsorForm,
			tagSuperSponsorForm,
			formRenew,
			formGoldLifetimeOffer,
			onInput,
			setRole,
			saveSponsor,
			tagSuperSponsor,
			addBCCModal,
			renewManualModal,
			saveMemberInfo,
			memberInfoForm,
			setRenewStatus,
			changePassword,
			welcomeCallModal,
			forcePasswordReset,
			cancelPasswordReset,
			showBeneficiariesModal,
			upgradeMembershipModal,
			resendPasswordResetLink,
			cancelSubscriptionModal,
			expiredDiscountModal,
			processGoldLifetimeOffer,
			downgradeMembershipModal,
			tagSuperSponsorConfirmModal,
			onCountryChange,
			signInLogsModal,
			renewSubscriptionManual,
		}
	},
}
</script>
